import { getUtcDate } from './get-utc-date';

export function getUtcTomorrow(): Date {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return getUtcDate(tomorrow);
}
